namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_prompt, {
		
		Copy: {
			background: {
				color: $mol_theme.back,
			},
			color: $mol_theme.text,
			margin: {
				left: 'auto',
			},
		},

		Form: {
			Foot: {
				paddingTop: '0',
			},
		},
		
	} )
	
}
